class BaseApi {
    private OmniaApi = '/api/omnia/v1'

    public InitialData = this.OmniaApi + '/initialData'
    public Page = this.OmniaApi + '/page'
    public PageList = this.OmniaApi + '/pageList'
    public Extensions = this.OmniaApi + '/extensions'
    public FilmExtension = this.OmniaApi + '/extensions/film'
    public ConcessionEnabled = this.OmniaApi + '/extensions/ticketing/concession-enabled'
    public Configuration = this.OmniaApi + '/configuration'

    public TrailerWatched = (filmHoCode: string) => this.OmniaApi + `/trailerwatched/${filmHoCode}`

    private OmniaConnectApi = '/api/omnia/connect/v1'
    public Genres = this.OmniaConnectApi + '/filmGenres'
    public Cinemas = this.OmniaConnectApi + '/cinemas'
    public Attributes = (name: string) => this.OmniaConnectApi + '/' + name

    public Search = (query: string) => this.OmniaApi + '/search?searchTerm=' + query

    public GoogleWallet = (orderId: string) => this.OmniaApi + `/wallet/google?orderId=${orderId}`
    public SamsungWallet = (orderId: string) => this.OmniaApi + `/wallet/samsung?orderId=${orderId}`

    public POST = async <T>(url: string, model: unknown, dontDeserialise = false): Promise<T | undefined> => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model),
        }

        const response = await fetch(url, requestOptions)

        if (dontDeserialise) {
            if (!response.ok) throw new Error(`Response status not expected (${response.status})`)
            return undefined
        } else {
            return (await response.json()) as T
        }
    }

    public GET = async <T>(url: string, dontDeserialise = false, signal?: AbortSignal): Promise<T | undefined> => {
        const response = await fetch(url, { signal })

        if (dontDeserialise) {
            if (!response.ok) throw new Error(`Response status not expected (${response.status})`)
            return undefined
        } else {
            return (await response.json()) as T
        }
    }
}

export const baseApi = new BaseApi()
